export default {
  get_configs: { method: "get", url: "api/configuracoes" },
  put_configs: { method: "put", url: "api/configuracoes" },
};
